"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDoctorAttendingApiResponseSchema = void 0;
const zod_1 = require("zod");
const api_1 = require("../global/api");
const profile_schema_1 = require("../global/profile.schema");
const doctor_attending_1 = require("./doctor-attending");
exports.createDoctorAttendingApiResponseSchema = zod_1.z.object({
    data: zod_1.z.object({
        id: zod_1.z.string().uuid(),
        type: (0, api_1.apiEntityTypeSchema)('doctor-attendings'),
        attributes: zod_1.z.object({
            firstname: zod_1.z.string(),
            lastname: zod_1.z.string(),
            phoneNumber: zod_1.z.string().nullable().default(null),
            orderRegistrationNumber: zod_1.z.string(),
            rhythm: zod_1.z.string().nullable().default(null),
            // Structured rhythm fields (SA = Sans Assistant, AA = Avec Assistant)
            onSiteSlotsWithoutAssistant: zod_1.z
                .number()
                .int()
                .min(0)
                .nullable()
                .default(null),
            remoteSlotsWithoutAssistant: zod_1.z
                .number()
                .int()
                .min(0)
                .nullable()
                .default(null),
            onSiteSlotsWithAssistant: zod_1.z
                .number()
                .int()
                .min(0)
                .nullable()
                .default(null),
            remoteSlotsWithAssistant: zod_1.z
                .number()
                .int()
                .min(0)
                .nullable()
                .default(null),
            doctolibId: zod_1.z.string().nullable().default(null),
            signatureUrl: profile_schema_1.signatureUrlSchema,
            iban: zod_1.z.string(),
            bic: zod_1.z.string().nullable().default(null),
            commissionRate: zod_1.z.coerce.number(),
            workSchedulesDateRef: zod_1.z.string().nullable(),
            workSchedules: doctor_attending_1.workSchedulesSchema,
            createdAt: zod_1.z.coerce.date(),
            activatedAt: zod_1.z.coerce.date().nullable(),
            deactivatedAt: zod_1.z.coerce.date().nullable().default(null),
        }),
    }),
});
